if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}


/* Citizen: quick-add modal = minimal colour+size picker with auto add-to-cart.
   Defaults are deselected on open; once every option group has a choice the
   item is added automatically (Dawn updates input[name=id] synchronously on
   change). After the add we close the modal, bump the header cart bubble and
   show a toast. Sold-out combos leave the button disabled — nothing is added
   until the shopper changes selection. */
(function () {
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.target && m.target.id && m.target.id.indexOf('QuickAddInfo-') === 0 && m.addedNodes.length) {
        var vr = m.target.querySelector('variant-radios');
        if (vr && !vr.dataset.citizenCleared) {
          vr.dataset.citizenCleared = '1';
          vr.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
        }
      }
    });
  }).observe(document.body, { childList: true, subtree: true });

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'citizen-added-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 400); }, 2200);
  }

  function bumpBubble(count) {
    var b = document.querySelector('.cart-count-bubble');
    if (!b) {
      var icon = document.querySelector('a[href*="/cart"] .header__icon, #cart-icon-bubble');
      if (icon) { b = document.createElement('div'); b.className = 'cart-count-bubble'; (document.querySelector('#cart-icon-bubble') || icon).appendChild(b); }
    }
    if (b) b.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
  }

  document.addEventListener('change', function (e) {
    var modal = e.target.closest && e.target.closest('quick-add-modal');
    if (!modal) return;
    var vr = e.target.closest('variant-radios');
    if (!vr) return;
    var fieldsets = vr.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      if (!fieldsets[i].querySelector('input:checked')) return;
    }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (before) {
      setTimeout(function () {
        var btn = modal.querySelector('form[data-type="add-to-cart-form"] [type="submit"], .product-form__submit');
        if (!btn || btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;
        btn.click();
        var tries = 0;
        var poll = setInterval(function () {
          tries++;
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            if (cart.item_count > before.item_count) {
              clearInterval(poll);
              bumpBubble(cart.item_count);
              try { modal.hide(true); } catch (err) { modal.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); }
              toast('Added to cart');
            } else if (tries > 10) { clearInterval(poll); }
          });
        }, 500);
      }, 400);
    });
  }, true);
})();
